"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSet = void 0;
exports.isSet = (value) => value instanceof Set;
//# sourceMappingURL=is-set.js.map